import { UserInfoFields } from '../../../firebase/document-field.enums';
import { FilterModel } from './filter.model';
import { FilterType } from './filter.type';
import { YES_NO_FILTER_OPTIONS } from './yes-no-filter-options';

export const USER_LIST_FILTERS: FilterModel[] = [
  {
    fieldName: UserInfoFields.roles,
    label: 'common.userFields.roles',
    type: FilterType.select,
    search: {
      label: 'common.listFilters.searchOptions',
      emptyLabel: 'common.listFilters.noOptionMatches',
    },
    value: '',
  },
  {
    fieldName: UserInfoFields.should_hide_not_registered_users,
    label: 'common.userSearchFilters.shouldHideNotRegisteredUsers',
    type: FilterType.radio,
    options: YES_NO_FILTER_OPTIONS,
    value: '',
  },
  {
    fieldName: UserInfoFields.is_flagged_for_deactivation,
    label: 'common.userSearchFilters.isFlaggedForDeactivation',
    type: FilterType.radio,
    options: YES_NO_FILTER_OPTIONS,
    value: '',
  },
  {
    fieldName: UserInfoFields.is_demo_account,
    label: 'common.userSearchFilters.showDemoAccounts',
    type: FilterType.radio,
    options: YES_NO_FILTER_OPTIONS,
    value: '',
  },
  {
    fieldName: UserInfoFields.known_reproductive_disorder,
    label: 'common.userFields.fertilityDisorder',
    type: FilterType.select,
    search: {
      label: 'common.listFilters.searchOptions',
      emptyLabel: 'common.listFilters.noOptionMatches',
    },
    value: '',
  },
];
